import { lazy } from 'react';
import { ModalIds } from '@constants';
import { register } from './modalManager';

// Consent / privacy-center modals, registered as React.lazy (each its own chunk).
// Imported for side effects from the consent surface (see dynamic-center.jsx).
register(ModalIds.CONSENT_CENTER_MODAL, lazy(() => import('@pages/consent-center-modal-v2/consent-center-modal-v2')));
register(ModalIds.PRIVACY_CENTER_MODAL, lazy(() => import('@pages/privacy-center-modal/privacy-center-modal')));
